export const parseTimeToSeconds = (timeStr: string): number => {
  const [minutesPart, rest] = timeStr.split(":");
  const [secondsPart, msPart] = (rest || "0").split(".");
  return (
    parseInt(minutesPart, 10) * 60 +
    parseInt(secondsPart, 10) +
    parseInt(msPart || "0", 10) / 1000
  );
};

export const formatDurationExact = (seconds: number): string => {
  const safe = Math.max(0, seconds);
  const minutes = Math.floor(safe / 60);
  const remainder = safe - minutes * 60;
  const wholeSeconds = Math.floor(remainder);
  let millis = Math.round((remainder - wholeSeconds) * 1000);

  let secs = wholeSeconds;
  if (millis === 1000) {
    secs += 1;
    millis = 0;
  }

  return `${minutes.toString().padStart(2, "0")}:${secs
    .toString()
    .padStart(2, "0")}.${millis.toString().padStart(3, "0")}`;
};

export const formatTime = (frame: number, fps: number): string => {
  const seconds = Math.floor(frame / fps);
  const minutes = Math.floor(seconds / 60);

  const milliseconds = 1000 / fps;

  const remainingSeconds = seconds % 60;

  return `${minutes.toString().padStart(2, "0")}:${remainingSeconds
    .toString()
    .padStart(2, "0")}.${Math.round(milliseconds * (frame % fps))
    .toString()
    .padStart(3, "0")
    .slice(0, 3)}`;
};
